// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Fb: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 19 40" enableBackground="new 0 0 19 40" xmlSpace="preserve">
<path fillRule="evenodd" fill="currentColor" clipRule="evenodd" d="M12.53,12.95V8.8c0-1.56,1.06-1.92,1.8-1.92h4.57V0.02L12.61,0
	C5.62,0,4.04,5.11,4.04,8.38v4.57H0v7.06h4.04V40h8.49V20.01h5.73L19,12.95H12.53z"/>
</svg>;
};

export default React.memo(Fb);
